import type { ReactNode } from "react";

export const inputCls =
  "w-full border border-stone/70 bg-chalk px-4 py-3 font-garamond text-lg text-ink outline-none transition-colors duration-300 placeholder:text-stone focus:border-marine";

export const labelCls =
  "mb-2 block font-oswald text-[11px] uppercase tracking-[0.3em] text-marine";

export const Field = ({
  label,
  htmlFor,
  optional = false,
  children,
}: {
  label: string;
  htmlFor: string;
  optional?: boolean;
  children: ReactNode;
}) => (
  <div>
    <label htmlFor={htmlFor} className={labelCls}>
      {label}
      {optional && (
        <span className="ml-2 normal-case tracking-normal text-stone">
          (optional)
        </span>
      )}
    </label>
    {children}
  </div>
);

export const Honeypot = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) => (
  <div aria-hidden="true" className="absolute -left-[9999px] h-0 w-0 overflow-hidden">
    <label htmlFor="website">Website</label>
    <input
      id="website"
      name="website"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);
